module.exports = __webpack_public_path__ + "static/media/line.934b3738.svg";